import styled from 'styled-components';

export default styled.div`
  && {
    @media only screen and (max-width: 1024px) and (min-width: 768px) {
      .header1 .ant-steps {
        padding-right: 0 !important;
      }
    }
    width: 100%;
    .inline {
      display: inline-block;
    }
    .header1 {
      height: 172px;
      background-color: rgba(193, 225, 141, 1);
      padding: 25px 40px;
      .icon1 {
        margin-right: 10px;
        margin-bottom: 25px;
        font-size: 20px;
      }
      .ant-steps {
        background-color: white;
        border-radius: 23.5px;
        .ant-steps-item-icon {
          border-color: white;
          background: rgba(196, 196, 196, 1);
        }
      }
      .ant-steps {
        padding-right: 35%;
      }
      .ant-steps-navigation .ant-steps-item-container {
        padding-bottom: 10px;
      }
      .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color: white;
      }
      .ant-steps-navigation .ant-steps-item::after {
        :first-child {
          left: 85%;
        }
        left: 93%;
      }
      .ant-steps-item-process {
        .ant-steps-item-icon {
          background: #c1e18d;
          border-color: white;
        }
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
      }
      .ant-steps-item-wait {
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
      .ant-steps-item::before {
        display: none;
      }
    }
    .header2 {
      height: 68px;
      background-color: rgba(236, 255, 184, 1);
      padding-right: 65px;
      padding-left: 65px;
      display: flex;
      align-items: center;
      .anticon-plus {
        font-size: 25px;
      }
      .plus {
        font-size: 30px;
        height: 56px;
        width: 56px;
        color: white;
        background-color: #ff8a00;
        border-radius: 50%;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      }
      .pts-right {
        position: absolute;
        right: 65px;
        top: 290px;
      }
    }
    .btnBack {
      background-color: rgba(235, 164, 80, 1);
      color: white;
      border: none;
      border-radius: 0;
      bottom: -12px;
    }
    .ant-tooltip {
      color: rgba(235, 164, 80, 1);
    }
    .last {
      left: -19px;
    }
    div[role='tooltip'] {
      color: rgba(235, 164, 80, 1);
    }
  }
`;
